// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class OptionView extends Component {

  static propTypes = {
    isActivated: PropTypes.bool.isRequired,

    onChange: PropTypes.func,

    label: PropTypes.string.isRequired,

    // Set to true to disable the interaction (will display a full black square)
    isDisabled: PropTypes.bool,

    readOnly: PropTypes.bool,

    className: PropTypes.string // TODO: could be an object too.
  };

  static defaultProps = {
    onChange: () => {},
    isDisabled: false,
    readOnly: false,
    className: ''
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.isActivated !== this.props.isActivated
    || nextProps.isDisabled !== this.props.isDisabled;
  }

  onClick = (event: Event) => {
    if (!this.props.isDisabled && !this.props.readOnly) {
      this.props.onChange(!this.props.isActivated);
    }
  };

  renderIcon() {
    let className = 'fa fa-square-o';

    if (this.props.isDisabled) {
      className = 'fa fa-square-o';
    } else if (this.props.isActivated === true) {
      className = 'fa fa-check-square-o';
    }

    return (
      <i className={className} />
    )
  }

  render() {
    const className = classNames('option_view', this.props.className, {
      disabled: this.props.isDisabled,
      activated: this.props.isActivated,
      read_only: this.props.readOnly
    });

    return (
      <div className={className} onClick={this.onClick}>
        {this.renderIcon()}
        &nbsp;&nbsp;
        {this.props.label}
      </div>
    );
  }

}

export default OptionView;



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/OptionView.js